module.exports = __webpack_public_path__ + "img/home_hero.694df496.png";